<template>

    <div class="flex flex-col">

        <div class="flex  w-full bg-gray-200 shadow-lg items-center mb-4">
            <div class="flex py-4 px-4 items-center  text-gray-700 hover:text-black cursor-pointer" @click="goBack">
                <ArrowLeftIcon class="mr-1 h-6 w-8 object-cover" ></ArrowLeftIcon>
<!--                <p class="text-lg">Back</p>-->
            </div>

            <p class="flex visible justify-center text-center"> Add Announcement</p>

        </div>

        
        <div v-if="info_loading" class="h-screen w-full">
        <div class="flex h-screen items-center">
          <vue-loaders
            name="ball-spin-fade-loader"
            color="#2a4365"
            class="flex m-auto my-4"
            scale="1"
          ></vue-loaders>
        </div>
      </div>


        <div v-else class="w-full md:w-2/3 py-6 px-3 md:m-auto">

            <div class="px-3 mb-6 md:mb-0">
                <label class="block uppercase tracking-wide text-grey-darker text-xs font-bold mb-2" for="title">
                    Title <span class="text-red-600">*</span>
                </label>
                <input class="block w-full bg-gray-200 text-grey-darker border outline-none focus:shadow-outline
                    rounded py-3 px-4 mb-3 border-gray-400" id="title" type="text" placeholder="Title" v-model="announcement.title">
            </div>

            <div class="px-3 mb-6 md:mb-0">
                <label class="block uppercase tracking-wide text-grey-darker text-xs font-bold mb-2" for="announcer">
                    Announcer <span class="text-red-600">*</span>
                </label>
                <input class="block w-full bg-gray-200 text-grey-darker border outline-none focus:shadow-outline
                    rounded py-3 px-4 mb-3 border-gray-400" id="announcer" type="text" placeholder="Adekunle Ciroma" v-model="announcement.announcer">
            </div>

            <div class="px-3 mb-6 md:mb-0">
                <label class="block uppercase tracking-wide text-grey-darker text-xs font-bold mb-2" for="content">
                    Content <span class="text-red-600">*</span>
                </label>
                <textarea class="block w-full bg-gray-200 text-grey-darker border outline-none focus:shadow-outline
                    rounded py-3 px-4 mb-3 border-gray-400 h-56" id="content" placeholder="main content of the announcement" v-model="announcement.contents"></textarea>
            </div>


        
            <div>
                <div v-if="save_loading" class="flex mx-auto mb-3" >
                        <vue-loaders name="ball-spin-fade-loader" color="#2a4365" class="mx-auto my-4" scale="1">
                        </vue-loaders>
                </div>

                <div v-else  class="mx-3">
                    <button @click="save"
                            class="flex mx-auto bg-blue-700 hover:bg-blue-900 text-white justify-center capitalize tracking-wider text-sm
                        font-semibold px-10 py-3 mb-3 rounded w-full">
                        Save
                    </button>
                </div>
            
            </div>


        </div>




    </div>

</template>

<script>
    import {ArrowLeftIcon} from 'vue-feather-icons';
    import Axios from 'axios';

    export default {
        name: "AddEditAnnouncement",
        components: {ArrowLeftIcon},
        props: {add: Boolean},

        data: function(){
            return {
                save_loading: false,
                info_loading: false,
                announcement: {},
                error: false,
            }
        },
        methods: {
            goBack(){
                this.$router.back();
            },

            save(e){
                this.save_loading = true;
                let token = localStorage.getItem('token');
                if(token !== null){
                    if(this.add){
                        Axios.post('/api/announcements',
                            this.announcement,
                            {headers: {'Content-Type': 'application/json',
                                    'Authorization': `Bearer ${token}`}
                            }).then(response => {
                                this.save_loading = false;
                                if(response.data.status === true){
                                    this.$swal({
                                        title: 'Announcement saved successfully',
                                        toast:  true,
                                        showConfirmButtone: false,
                                        position: 'top-end',
                                        timer: 3000
                                        });
                                    this.$router.back();
                                }else{
                                    this.$swal(response.data.message);
                                }
                        });
                    }else{
                    
                        let id = this.$route.params.id;
                        if(id !== null){
                            Axios.patch(`/api/announcements/${id}`,
                                this.announcement,
                                {headers: {'Content-Type': 'application/json',
                                        'Authorization': `Bearer ${token}`}
                                }).then(response => {
                                    this.save_loading = false;
                                if(response.data.status === true){
                                    this.$swal({
                                        title: 'Announcement saved successfully',
                                        toast:  true,
                                        showConfirmButton: false,
                                        position: 'top-end',
                                        timer: 3000
                                    });
                                    this.$router.back();
                                }
                            });
                        }else{
                            this.$swal('Please login');
                            this.$router.push('/');
                        }

                    }

                }else{
                    this.$swal('Please login');
                    this.$router.push('/');
                }

                e.preventDefault();

            },

            getAnnouncementDetails: function(){
                if(!this.add){
                    this.info_loading = true;
                    this.error = null;
                    // let id = router.params.id;
                    let id = this.$route.params.id;
                    let token = localStorage.getItem('token');

                    // console.log(id);
                    // console.log(token);
                    if(token === null){
                        this.router.push('/');
                        this.$swal({
                                    title: 'Please login',
                                        toast:  true,
                                        showConfirmButtone: false,
                                        position: 'top-end',
                                        timer: 1500
                                        });
                    }else{
                        Axios.get(`/api/announcements/${id}`, {
                            headers: {'Content-Type': 'application/json',
                                'Authorization': `Bearer ${token}`}
                        }).then(response => {
                            this.info_loading = false;
                            // console.log(response.data);
                            if(response.data.status === true){
                                this.announcement = response.data.data;
                            }else{
                                // this.error = '404: Not found';
                                this.router.push('/');
                                this.$swal({
                                    title: 'Please login',
                                        toast:  true,
                                        showConfirmButtone: false,
                                        position: 'top-end',
                                        timer: 1500
                                        });
                            }
                        }).catch(e => {
                            // this.error = e.toString();
                            this.info_loading = false;
                            e.toString();
                            this.error = 'Page not found';
                        })
                    }
                }


            }
        },
        created() {
            this.getAnnouncementDetails();
        }

    }
</script>

<style scoped>

</style>
